import React from 'react';
export function ModulesSection() {
  const modules = [{
    num: '01',
    title: 'Empezá bien con tu freidora',
    desc: 'Dominás los tiempos y temperaturas — sin quemar ni deshidratar nada'
  }, {
    num: '02',
    title: 'Recetas rápidas para el día a día',
    desc: 'Tenés opciones listas en 15 minutos para cualquier día de semana'
  }, {
    num: '03',
    title: 'Almuerzos que te llenan',
    desc: 'Platos completos que no te dejan con hambre a las 3 de la tarde'
  }, {
    num: '04',
    title: 'Cenas livianas para dormir bien',
    desc: 'Comés rico a la noche sin sentirte pesada ni inflada'
  }, {
    num: '05',
    title: 'Snacks sin culpa',
    desc: 'Cuando tenés antojo a las 4 pm, tenés opciones ricas que no arruinan el día'
  }, {
    num: '06',
    title: 'Tu comida chatarra, versión sana',
    desc: 'Papas, milanesas, nuggets, pizza — sin freír, sin remordimiento'
  }, {
    num: '07',
    title: 'Organizá tu semana en 10 minutos',
    desc: 'El domingo planeás todo y el resto de la semana solo ejecutás'
  }];
  return <section className="py-20 px-4 bg-brand-purpleLight" data-id="element-119">
      <div className="max-w-5xl mx-auto" data-id="element-120">
        <div className="text-center mb-16" data-id="element-121">
          <div className="inline-flex bg-white text-brand-purpleDark px-4 py-1.5 rounded-full font-semibold text-sm mb-6 shadow-sm" data-id="element-122">
            Qué incluye
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-darkGray" data-id="element-123">
            7 módulos — cada uno resuelve un momento de tu semana
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-124">
          {modules.map((mod, index) => <div key={index} className={`bg-white p-6 rounded-2xl shadow-sm border border-brand-purple/10 flex flex-col ${index === 6 ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''}`} data-id="element-125">
              <div className="flex items-center gap-3 mb-3" data-id="element-126">
                <div className="bg-brand-purple text-brand-yellow font-bold px-3 py-1 rounded-lg text-sm" data-id="element-127">
                  {mod.num}
                </div>
                <h3 className="font-bold text-brand-darkGray text-lg" data-id="element-128">
                  {mod.title}
                </h3>
              </div>
              <p className="text-brand-mediumGray font-medium pl-14" data-id="element-129">
                {mod.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}